import { createElement } from 'react';
var checkJssError = function checkJssError(props, component, optionalFieldCheckOnNull) {
  var fields = props.fields;
  var dataSource = props.dataSource || props.rendering.dataSource;
  var componentName = props.componentName || props.rendering.componentName || props.params.eventAct;
  if (fields.errors) {
    console.warn("".concat(componentName, " component render skipped. Error message ").concat(fields.errors[0].message));
    return null;
  }
  if (dataSource.trim() === "") {
    console.warn("".concat(componentName, " component render skipped. dataSource is empty"));
    return null;
  }
  if (optionalFieldCheckOnNull === null) {
    console.warn("".concat(componentName, " component render skipped. required field return null"));
    return null;
  }
  return /*#__PURE__*/createElement(component, props);
};
export { checkJssError };